import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.css';
import { App } from './App';

import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import { HoneybadgerApiKey, HoneybadgerEnv } from './config/Config';
import { ErrorPage } from './pages/ErrorPage';

const honeybadger = Honeybadger.configure({
  apiKey: HoneybadgerApiKey,
  environment: HoneybadgerEnv,
  breadcrumbsEnabled: {
    console: false,
  },
});

honeybadger.beforeNotify(notice => {
  if (notice.message.includes('ResizeObserver')) {
    return false;
  }
});

ReactDOM.render(
  <React.StrictMode>
    <HoneybadgerErrorBoundary honeybadger={honeybadger} ErrorComponent={ErrorPage}>
      <App />
    </HoneybadgerErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
